/**
 * English: Pie chart showing cost breakdown by model.
 * Thai: Pie chart แสดงการแบ่ง cost ตาม model
 */
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';

interface CostBreakdownChartProps {
  data: Record<string, { calls: number; cost_usd: number; input_tokens: number; output_tokens: number }>;
}

const PALETTE = [
  'rgb(var(--color-app-accent))',
  'rgb(var(--color-app-master))',
  'rgb(var(--color-app-success))',
  'rgb(var(--color-app-warning))',
  'rgb(var(--color-app-user))',
  'rgb(var(--color-app-error))',
];

export default function CostBreakdownChart({ data }: CostBreakdownChartProps) {
  const entries = Object.entries(data)
    .map(([model, stats]) => ({
      name: model.split('/').pop() || model,
      value: Number(stats.cost_usd.toFixed(4)),
    }))
    .filter((e) => e.value > 0)
    .sort((a, b) => b.value - a.value);

  if (!entries.length) return null;

  return (
    <ResponsiveContainer minWidth={1} minHeight={1} width="100%" height={240}>
      <PieChart>
        <Pie
          data={entries}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={2}
          dataKey="value"
          nameKey="name"
          label={({ name, percent }) => `${name} ${((percent ?? 0) * 100).toFixed(0)}%`}
          labelLine={false}
          fontSize={11}
        >
          {entries.map((_, i) => (
            <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            background: 'rgb(var(--color-app-surface))',
            border: '1px solid rgb(var(--color-app-border))',
            borderRadius: 8,
            fontSize: 13,
          }}
          formatter={(value) => [`$${Number(value).toFixed(4)}`, 'Cost']}
        />
        <Legend
          wrapperStyle={{ fontSize: 12, color: 'rgb(var(--color-app-text-sec))' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
